import React from "react";
// @ts-ignore - createPortal is available in react-dom but types may not be complete
import { createPortal } from "react-dom";

interface LogoutModalProps {
  onClose: () => void;
  blurBackground?: boolean;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ onClose, blurBackground = true }) => {
  const modalContent = (
    <div className={`modal-overlay ${blurBackground ? "" : "no-blur"}`}>
      <div className="modal-content logout-modal animate__animated animate__fadeIn">
        <div className="logout-modal__icon">
          <span className="material-symbols-outlined notranslate">check_circle</span>
        </div>
        <h2 className="logout-modal__title">You've been logged out</h2>
        <p className="logout-modal__message">
          Your session has ended successfully. Thank you for visiting!
        </p>
        <button onClick={onClose} className="btn green logout-modal__button">
          Got it
        </button>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default LogoutModal;
